{
  "name": "borgo-kyc-admin",
  "version": "1.1.1-5041068d.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.3",
    "@angular/common": "^20.3.3",
    "@angular/compiler": "^20.3.3",
    "@angular/core": "^20.3.3",
    "@angular/forms": "^20.3.3",
    "@angular/platform-browser": "^20.3.3",
    "@angular/platform-browser-dynamic": "^20.3.3",
    "@angular/router": "^20.3.3",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.4",
    "@angular/cdk": "^20.2.7",
    "@angular/cli": "^20.3.4",
    "@angular/compiler-cli": "^20.3.3",
    "@angular/material": "^20.2.7",
    "@angular/material-luxon-adapter": "^20.2.7",
    "@sparbanken-syd/auth-backend": "^2.4.2",
    "@sparbanken-syd/borgo-kyc-be": "^1.0.8",
    "@sparbanken-syd/borgo-types": "^1.0.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^20.1.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^20.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^20.2.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^20.2.2",
    "@types/jasmine": "~5.1.9",
    "@types/luxon": "^3",
    "@typescript-eslint/eslint-plugin": "^8.46.0",
    "@typescript-eslint/parser": "^8.46.0",
    "angular-eslint": "^20.3.0",
    "eslint": "^9.37.0",
    "jasmine-core": "~5.12.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "luxon": "^3.7.2",
    "postcss": "^8.5.6",
    "stylelint": "^16.25.0",
    "stylelint-config-sass-guidelines": "^12.1.0",
    "stylelint-config-standard-scss": "^16.0.0",
    "stylelint-scss": "^6.12.1",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.46.0"
  }
}
